import React, { useContext } from "react";// Assuming ThemeContext exists
import dayjs from "dayjs"; // For formatting dates
import { useTheme } from "../context/ThemeContext";
import Card from "./Card";

const QuizInformation = ({ quiz, startQuiz }) => {
    const { theme, themeStyles } = useTheme();

    const cardStyles = {
        light: "bg-white text-gray-800 border-gray-300",
        dark: "bg-gray-800 text-white border-gray-600",
    };

    const buttonStyles = {
        light: "bg-blue-500 hover:bg-blue-600 text-white",
        dark: "bg-blue-700 hover:bg-blue-800 text-white",
    };

    return (
        <Card type="column" className="mx-auto" padding={"20px"} maxWidth={true} minWidth={true}
        // className={`border rounded-lg shadow-lg p-6 w-full max-w-md mx-auto`}
        // style={{
        //     background: themeStyles.cardBackground,
        //     color: themeStyles.text
        // }}
        >
            {quiz.quizPicture && <img className="mx-auto" src={quiz.quizPicture} width={300} height={300} style={{ maxWidth: 200, maxHeight: 200, borderRadius: 20, marginBottom: 20 }} />}
            <div className="mb-4">
                <h2 className="text-2xl font-semibold">{quiz.name}</h2>
                <p>
                    {quiz.description}
                </p>
            </div>

            <p className="mb-2">
                <strong>Quiz Expiry Date:</strong> {dayjs(quiz.endDate).format("DD MMM YYYY")}
            </p>
            <p className="mb-2">
                <strong>Total Marks:</strong> {quiz.totalMarks}
            </p>
            <p className="mb-2">
                <strong>Time Limit:</strong> {quiz.timeLimit} minutes
            </p>
            <button
                onClick={startQuiz}
                className={`w-full font-bold mt-4 py-2 rounded transition-all ${theme === "dark" ? buttonStyles.dark : buttonStyles.light
                    }`}
            >
                Start Quiz
            </button>
        </Card>
    );
};

export default QuizInformation;
